module.exports = __webpack_public_path__ + "img/simone-dinardodimaio.85fab186.jpg";